import React, { Component } from 'react';

import data from '../../../bloodfooddata.json'

import Results from './results'
import Search from './search'

    // { data.forEach( (item, i) => {
    //     <div> { JSON.stringify(item) } </div>
    // })}
// const Home = () => (
//   <div>
//     <h1>Hello, {formatName(user)}!</h1>
//   </div>
// )
// 
class Home extends Component {

    constructor(props) {
        super(props)
        this.state = {
            query: "",
        }
    }

    render() {
        let filtered = Object.assign(data)
        if(this.state["query"].length >= 1) {
            filtered = Object.keys(filtered)
                .filter(key => key.toLowerCase().includes(this.state.query.toLowerCase()))
                .reduce((obj, key) => {
                    obj[key] = data[key];
                    return obj;
                }, {})
        }
        const count = Object.keys(filtered).length
        let cont = <div className="note"> Please enter a search query to narrow the results </div>
        if (count == 0) {
            cont = <div className="note"> No food names match &quot;{ this.state.query }&quot;</div>
        } else if (count < 50) {
            cont = <Results results={filtered} />
        }

        return (
            <div>
                <h1> Foods List </h1>
                <Search update={(val) => this.setState({query: val})} query={this.state.query} />
                <div style={{ clear: "both" }}>
                    { cont }
                </div>
            </div>
        )
    }
}


export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js